import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import { WorkListScreen } from './work/list/WorkListScreen';
import { WorkDetailScreen } from './work/detail/WorkDetailScreen';
import { WorkerListScreen } from './worker/list/WorkerListScreen';
import { WorkerCreateScreen } from './worker/form/create/WorkerCreateScreen';
import { WorkerUpdateScreen } from './worker/form/update/WorkerUpdateScreen';
import { MachineListScreen } from './machine/list/MachineListScreen';
import { MachineCreateScreen } from './machine/form/create/MachineCreateScreen';
import { MachineUpdateScreen } from './machine/form/update/MachineUpdateScreen';
import { DocumentsScreen } from './document/DocumentsScreen';
import { ContractorListScreen } from './contractor/list/ContractorListScreen';
import { PsRoutes } from '../shared/routing/Routes';
import { WorkerDocumentDetailScreen } from './document/WorkerDocumentDetailScreen';
import { MachineDocumentDetailScreen } from './document/MachineDocumentDetailScreen';
import { OutsourceDocumentDetailScreen } from './document/OutsourceDocumentDetailScreen';

export class MyContractorRouting extends React.Component {

    render() {
        const { currentUser } = this.props;

        if ( currentUser.isAdmin() || currentUser.isContractorsManager() ) {
            return (
                <React.Fragment>
                    <Route exact path={PsRoutes.MY_CONTRACTORS_WORKS} component={WorkListScreen}/>
                    <Route exact path={PsRoutes.MY_CONTRACTORS_WORKS_DETAIL} component={WorkDetailScreen}/>
                    <Route exact path={PsRoutes.MY_CONTRACTORS_WORKERS} component={WorkerListScreen}/>
                    <Route exact path={PsRoutes.MY_CONTRACTORS_WORKERS_DETAIL} component={WorkerUpdateScreen}/>
                    <Route exact path={PsRoutes.MY_CONTRACTORS_WORKERS_ADD} component={WorkerCreateScreen}/>
                    <Route exact path={PsRoutes.MY_CONTRACTORS_WORKERS_DOCUMENTS_DETAIL} component={WorkerDocumentDetailScreen}/>
                    <Route exact path={PsRoutes.MY_CONTRACTORS_MACHINES} component={MachineListScreen}/>
                    <Route exact path={PsRoutes.MY_CONTRACTORS_MACHINES_DETAIL} component={MachineUpdateScreen}/>
                    <Route exact path={PsRoutes.MY_CONTRACTORS_MACHINES_ADD} component={MachineCreateScreen}/>
                    <Route exact path={PsRoutes.MY_CONTRACTORS_MACHINES_DOCUMENTS_DETAIL} component={MachineDocumentDetailScreen}/>
                    <Route exact path={PsRoutes.MY_CONTRACTORS_DOCUMENTS} component={DocumentsScreen}/>
                    <Route exact path={PsRoutes.MY_CONTRACTORS_DOCUMENTS_DETAIL} component={OutsourceDocumentDetailScreen}/>
                    <Route exact path={PsRoutes.MY_CONTRACTORS} component={ContractorListScreen}/>
                </React.Fragment>
            );
        }

        return null;
    }
}

MyContractorRouting.propTypes = {
    currentUser: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/app/my-contractors/MyContractorsRouting.jsx